import { Close } from "@common/schemas/close.schema";
import { DateRangeDisplay } from "@components/settings/OrganizationCloseTemplates/DateRangeDisplay";
import styles from "./TaskViewCells.module.scss";

interface CloseGroupTitleProps {
    close: Close;
    entityName: string | null;
}

export const CloseGroupTitle = ({
    close,
    entityName,
}: CloseGroupTitleProps) => {
    const hasDates = close.startDate !== null || close.endDate !== null;

    return (
        <span className={styles.closeGroupTitle}>
            <span className={styles.closeGroupName}>{close.name}</span>
            {entityName ? (
                <span className={styles.closeGroupEntity}>{entityName}</span>
            ) : null}
            {hasDates ? (
                <span className={styles.closeGroupDates}>
                    <DateRangeDisplay
                        startDate={close.startDate}
                        endDate={close.endDate}
                    />
                </span>
            ) : null}
        </span>
    );
};
